/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DashboardDto } from '../../models/dashboard-dto';

export interface DashboardFavoritesUserGet$Plain$Params {
}

export function dashboardFavoritesUserGet$Plain(http: HttpClient, rootUrl: string, params?: DashboardFavoritesUserGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DashboardDto>>> {
  const rb = new RequestBuilder(rootUrl, dashboardFavoritesUserGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DashboardDto>>;
    })
  );
}

dashboardFavoritesUserGet$Plain.PATH = '/dashboard-favorites/user';
